<div class="auth-page-wrapper pt-5">
    <div class="auth-page-content">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="card mt-4">
                        <div class="card-body p-4">
                            <div class="text-center mt-2">
                                <h5 class="text-primary">Welcome Back !</h5>
                                <p class="text-muted">Sign in to continue to E-Commerce<br>Admin Portal</p>
                            </div>
                            <div class="p-2 mt-4">
                                <form (ngSubmit)="login()">
                                    <div class="mb-3">
                                        <label for="email" class="form-label">Email</label>
                                        <input type="text" class="form-control" id="email" name="email" placeholder="Enter email" [(ngModel)]="customer.email" autocomplete="username" [class.is-invalid]="showErrorMessage">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label" for="password-input">Password</label>
                                        <div class="position-relative auth-pass-inputgroup mb-3">
                                            <input
                                                [type]="showPassword ? 'text' : 'password'"
                                                class="form-control pe-5 password-input"
                                                placeholder="Enter password"
                                                id="password-input"
                                                name="password"
                                                [(ngModel)]="customer.password"
                                                autocomplete="current-password">
                                            <button
                                                type="button"
                                                class="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none text-muted password-addon"
                                                (click)="showPassword = !showPassword">
                                                <i class="ri-eye-fill align-middle"></i>
                                            </button>
                                        </div>
                                        <div *ngIf="showErrorMessage" class="text-danger">Invalid Email or Password</div>
                                        <div *ngIf="accountNotActivated" class="text-danger">Your account is not activated. Please check your email for the activation link.</div>
                                    </div>

                                    <div class="mt-4">
                                        <button class="btn btn-success w-100" type="submit">Sign In</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
